import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useFetchProduct from "../adminDashboard/products/useFetchProduct";
import ProductCard from "../adminDashboard/products/utils/ProductCard";
import Pagination from "../adminDashboard/products/utils/Pagination";

const CategoryProducts = () => {
  const { categoryId } = useParams();
  const [page, setPage] = useState(1);
  const {
    products: categoryProducts,
    isLoading,
    error,
    totalPages,
    currentPage,
  } = useFetchProduct({
    categories: categoryId,
    page,
    limit: 8,
  });

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [categoryId]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#DA0E1A]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-600 py-8">
        Error loading products. Please try again later.
      </div>
    );
  }

  // console.log("Category Products that causes the err: ", categoryProducts);
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8 text-gray-800">
        {categoryProducts?.data?.[0]?.category?.name || "Category"} Products
      </h1>
      {categoryProducts?.data?.length === 0 ? (
        <div className="text-center text-gray-600 py-8">
          No products found in this category.
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {categoryProducts?.data?.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
          </div>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          )}
        </>
      )}
    </div>
  );
};

export default CategoryProducts;
